define(function (require, exports, module) {
    'use strict';

    var AsyncRepeat = require('../async/AsyncRepeat');
    var UploadReason = require('../../UploadReason');
    var JavaScriptError = require('../../errors/JavaScriptError');
    var LocalFileNotFoundFail = require('../../fails/LocalFileNotFoundFail');
    var LocalFileNotReadableFail = require('../../fails/LocalFileNotReadableFail');
    var UnsupportedFolderTransferFail = require('../../fails/UnsupportedFolderTransferFail');

    /**
     * @namespace
     */
    var fileSystemEntryReader = {
        /**
         * @param {FileEntry} entry
         * @returns {Promise}
         * @resolves {File}
         * @rejects {Error}
         */
        getFile: function (entry) {
            var promise = new Promise(function (resolve, reject) {
                entry.file(resolve, reject);
            });

            promise = promise.catch(function (error) {
                var source = UploadReason.SOURCE_WEB_CLIENT;
                var stack;
                var reason;

                if (LocalFileNotFoundFail.isNotFoundError(error)) {
                    stack = new Error('LocalFileNotFoundFail');
                    reason = new LocalFileNotFoundFail(stack, source);
                } else if (entry.isDirectory && UnsupportedFolderTransferFail.isNotReadableError(error)) {
                    stack = new Error('UnsupportedFolderTransferFail');
                    reason = new UnsupportedFolderTransferFail(stack, source);
                } else if (LocalFileNotReadableFail.isNotReadableError(error)) {
                    stack = new Error('LocalFileNotReadableFail');
                    reason = new LocalFileNotReadableFail(stack, source);
                } else {
                    stack = new Error('JavaScriptError');
                    reason = new JavaScriptError(stack, source, error);
                }

                return Promise.reject(reason);
            });

            return promise;
        },

        /**
         * @param {DirectoryEntry} entry
         * @returns {Promise}
         * @resolves {DirectoryReader}
         * @rejects {Error}
         */
        createReader: function (entry) {
            var promise = new Promise(function (resolve) {
                var reader = entry.createReader();

                resolve(reader);
            });

            return promise;
        },

        /**
         * @param {DirectoryReader} reader
         * @returns {Promise}
         * @resolves {Array.<FileEntry|DirectoryEntry>}
         * @rejects {Error}
         */
        readEntries: function (reader) {
            var promise = new Promise(function (resolve, reject) {
                reader.readEntries(resolve, reject);
            });

            return promise;
        },

        /**
         * @param {DirectoryReader} reader
         * @returns {Promise}
         * @resolves {Array.<FileEntry|DirectoryEntry>}
         * @rejects {Error}
         */
        _readDirectory: function (reader) {
            // @type {Array.<FileEntry|DirectoryEntry>}
            var result = [];
            var promise = new AsyncRepeat(function (repeat, finish, thrower) {
                var promise = fileSystemEntryReader.readEntries(reader);

                promise = promise.then(function (entries) {
                    var count = entries.length;

                    // entries может быть объектом, похожим на Array,
                    // поэтому конкатинируем коллекции в цикле.
                    for (var i = 0, j = result.length; i < count; i++, j++) {
                        result[j] = entries[i];
                    }

                    if (count) {
                        // DirectoryReader может отдавать entries порциями,
                        // поэтому повторяем действия, пока получаем
                        // коллекцию ненулевой длины.
                        repeat();
                    } else {
                        finish(result);
                    }
                });

                promise.catch(function (reason) {
                    thrower(reason);
                });
            });

            return promise;
        },

        /**
         * @param {DirectoryEntry} entry
         * @returns {Promise}
         * @resolves {Array.<FileEntry|DirectoryEntry>}
         * @rejects {Error}
         */
        readDirectory: function (entry) {
            var promise = fileSystemEntryReader.createReader(entry);

            promise = promise.then(fileSystemEntryReader._readDirectory);

            return promise;
        },
    };

    module.exports = fileSystemEntryReader;
});
